import { makeStyles } from 'tss-react/mui';

const useStyles = makeStyles()((theme) => ({
  item: {
    width: '100%',
    marginBottom: '22px',
    '& .MuiTextField-root': {
      borderRadius: '12px'
    }
  },
  inputHelper: {
    color: theme.palette.grey.main,
    fontSize: '12px',
  },
  inputHelpBig: {
    color: theme.palette.grey.main,
    fontSize: '14px',
  },
  openBaliseTypeButton: {
    cursor: 'pointer',
    textDecoration: 'underline'
  },
  inputRow: {
    display: 'flex',
    alignItems: 'start',
    justifyContent: 'space-between'
  }
}));

export default useStyles;